import { directories } from "#site/content";
import type { DirectoryEntry } from "@/types";

const STATE_TAGS = new Set([
  "alabama", "alaska", "arizona", "arkansas", "california", "colorado",
  "connecticut", "florida", "georgia", "hawaii", "illinois", "indiana",
  "iowa", "kentucky", "louisiana", "maine", "maryland", "massachusetts",
  "michigan", "minnesota", "missouri", "nebraska", "nevada", "new-hampshire",
  "new-jersey", "new-york", "north-carolina", "northern-california", "ohio",
  "oklahoma", "oregon", "pennsylvania", "puerto-rico", "rhode-island",
  "south-carolina", "southern-california", "tennessee", "texas", "utah",
  "vermont", "virginia", "washington", "washington-dc", "west-virginia",
  "wisconsin",
]);

const CHARACTERISTIC_TAGS = new Set([
  "adaptive", "adults", "affordable", "all-levels", "coastal", "collegiate",
  "community", "competitive", "elite", "fitness", "free", "high-performance",
  "high-school", "historic", "inclusive", "juniors", "learn-to-row", "masters",
  "nonprofit", "olympic-venue", "open-water", "private", "public", "regattas",
  "sculling", "social", "sprint-course", "sweep", "veterans", "women", "ymca",
  "youth",
]);

function getClubsCategory() {
  return directories.find((d) => d.categorySlug === "clubs");
}

export function getAllClubs(): DirectoryEntry[] {
  const category = getClubsCategory();
  if (!category) return [];
  return [...category.entries].sort((a, b) => a.name.localeCompare(b.name));
}

export function getClubBySlug(slug: string): DirectoryEntry | undefined {
  const category = getClubsCategory();
  if (!category) return undefined;
  return category.entries.find((e) => e.slug === slug);
}

export function getGeocodedClubs(): DirectoryEntry[] {
  return getAllClubs().filter(
    (c) => c.latitude !== undefined && c.longitude !== undefined
  );
}

export function getUniqueStates(): string[] {
  const states = new Set<string>();
  for (const club of getAllClubs()) {
    for (const tag of club.tags) {
      if (STATE_TAGS.has(tag)) states.add(tag);
    }
  }
  return Array.from(states).sort();
}

export function getUniqueCharacteristics(): string[] {
  const chars = new Set<string>();
  for (const club of getAllClubs()) {
    for (const tag of club.tags) {
      if (CHARACTERISTIC_TAGS.has(tag)) chars.add(tag);
    }
  }
  return Array.from(chars).sort();
}

export function getClubState(club: DirectoryEntry): string | undefined {
  return club.tags.find((t) => STATE_TAGS.has(t));
}

export function getClubCharacteristics(club: DirectoryEntry): string[] {
  return club.tags.filter((t) => CHARACTERISTIC_TAGS.has(t));
}

export function formatTagLabel(tag: string): string {
  return tag
    .split("-")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}
